// extracted by mini-css-extract-plugin
export default {"wrapper":"fq-z","response":"gq-z","error":"hq-z","disabled":"iq-z","buttons":"jq-z","feedbackQuestionSection":"kq-z","yesNoWrapper":"lq-z"};